import { styled } from "styled-components";

export const Content = styled.div`
  width: 100%;
  padding: 48px 0;
`;

export const Text = styled.div`
  margin-top: 24px;

  p {
    margin-bottom: 32px;
  }

  ul {
    margin-top: 14px;
  }

  li {
    list-style-position: inside;
  }
`;
